import axios from 'axios';
import {
  clearStoredForumSession,
  FORUM_SESSION_KEY,
  notifyForumSessionExpired,
} from '@/lib/forumSession';

const BASE_URL =
  typeof window !== 'undefined'
    ? '/api'
    : process.env.BACKEND_BASE_URL;

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

apiClient.interceptors.request.use(
  async (config) => {
    if (typeof window !== 'undefined') {
      const rawSession = window.localStorage.getItem(FORUM_SESSION_KEY);

      if (rawSession) {
        try {
          const session = JSON.parse(rawSession);
          const accessToken = session?.token;

          if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
          }
        } catch {}
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      typeof window !== 'undefined' &&
      error?.response?.status === 401
    ) {
      clearStoredForumSession();
      notifyForumSessionExpired();
    }

    return Promise.reject(error);
  },
);

export default apiClient;
